import classNames from 'classnames';
import noop from 'lodash/noop';
import React from 'react';
import './InteractiveMapMarker.scss';

const MARKER_SVG_PATH =
    'M12.1230385,-1 C19.3706925,-1 25.2460769,4.87538444 25.2459656,12.1379605 L25.2401352,12.5211513 C25.1417542,15.8138369 23.8238074,18.9122297 21.5647242,21.2360825 L12.1362691,31.7952232 L11.3902364,30.962093 L2.71888509,21.2780022 L2.45764552,20.9990107 C0.221261174,18.5423325 -1,15.4205261 -1,12.1230385 C-1,4.87538444 4.87538444,-1 12.1230385,-1 Z';

interface InteractiveMapMarkerProps {
    eventsId: string[];
    onMapMarkerClick?: Function;
    hoverEventCardTarget?: string;
    selectedPinEvent?: string;
    tooltipSelectedEventsIds?: string[];
}

const shouldHighlight = (
    eventsId: string[],
    selectedPin: string,
    hoveredEvent: string,
    tooltipSelectedEventsIds?: string[],
) => {
    return (
        eventsId.toString() === tooltipSelectedEventsIds?.toString() ||
        eventsId.includes(selectedPin) ||
        eventsId.includes(hoveredEvent)
    );
};

export default class InteractiveMapMarker extends React.Component<InteractiveMapMarkerProps> {
    static defaultProps = {
        eventsId: [],
        onMapMarkerClick: noop,
    };

    shouldComponentUpdate(nextProps: InteractiveMapMarkerProps) {
        if (nextProps.eventsId.toString() !== this.props.eventsId.toString()) {
            return true;
        }

        //only change when not hovered and new one will cause hover
        //only change when hovered and new one will cause not hovered
        const currentlyHovered = shouldHighlight(
            this.props.eventsId,
            this.props?.selectedPinEvent || '',
            this.props?.hoverEventCardTarget || '',
            this.props.tooltipSelectedEventsIds,
        );
        const nextIsHovered = shouldHighlight(
            nextProps.eventsId,
            nextProps?.selectedPinEvent || '',
            nextProps?.hoverEventCardTarget || '',
            nextProps.tooltipSelectedEventsIds,
        );

        if (currentlyHovered && !nextIsHovered) {
            return true;
        }

        if (!currentlyHovered && nextIsHovered) {
            return true;
        }

        return false;
    }

    render() {
        const {
            eventsId,
            hoverEventCardTarget,
            onMapMarkerClick,
            selectedPinEvent,
            tooltipSelectedEventsIds,
        } = this.props;

        const shouldHover = shouldHighlight(
            eventsId,
            selectedPinEvent || '',
            hoverEventCardTarget || '',
            tooltipSelectedEventsIds,
        );

        const containerClassName = classNames(
            'interactive-map-marker__container',
            {
                'interactive-map-marker__container--hover': shouldHover,
            },
        );

        return (
            <div
                className={containerClassName}
                data-spec="interactive-map-marker-container"
            >
                <svg
                    className="interactive-map-marker"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="35"
                    tabIndex={1}
                    onClick={() => onMapMarkerClick?.(eventsId)}
                    onKeyDown={() => onMapMarkerClick?.(eventsId)}
                    onBlur={() => {
                        onMapMarkerClick?.([]);
                    }}
                    role="button"
                >
                    <path
                        fillRule="evenodd"
                        d={MARKER_SVG_PATH}
                        stroke="#2D2E3B"
                        strokeWidth="2px"
                        transform="translate(2 2)"
                    />
                </svg>
            </div>
        );
    }
}
